import type { Service } from '../../types/api';
import { CtaLink, Reveal, Section } from '../ui';
import { summary } from '../../utils/text';

/** Services du secteur: cartes sombres numérotées, comme les services liés de la référence. */
export default function ServiceNumberCards({ id, services }: { id: string; services: Service[] }) {
  if (services.length === 0) return null;
  return (
    <div id={id}>
      <Section eyebrow="Nos services" heading="Ce que nous réalisons dans ce secteur" background="surface" pattern="top-right">
        <ol className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.08}>
              <div className="group relative flex h-full flex-col overflow-hidden bg-charcoal p-8 text-white transition-transform duration-300 ease-out hover:-translate-y-1">
                <span aria-hidden className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 bg-brand transition-transform duration-500 ease-out group-hover:scale-x-100" />
                <div className="text-xs font-semibold tracking-[0.1rem] text-white/70">{String(i + 1).padStart(2, '0')}</div>
                <h3 className="mt-5 font-sans text-[1.375rem] font-semibold normal-case leading-snug tracking-normal text-white">{s.name}</h3>
                <p className="mt-4 flex-1 text-[1rem] leading-relaxed !text-white/80">{summary(s.description, 120)}</p>
                <div className="mt-8"><CtaLink to={`/services/${s.id}`} tone="light">En savoir plus</CtaLink></div>
              </div>
            </Reveal>
          ))}
        </ol>
      </Section>
    </div>
  );
}
